"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultRecentlyViewedTranslate = exports.defaultSavePropertiesTranslate = void 0;
exports.defaultSavePropertiesTranslate = {
    title: 'Saved Properties',
    caption: 'Manage your saved properties',
    emptyTitle: 'You don\'t have saved properties yet',
    emptyCaption: 'You can save property by clicking the \'heart\' icon'
};
exports.defaultRecentlyViewedTranslate = {
    title: 'Recently Viewed',
    caption: 'Properties you viewed earlier',
    emptyTitle: 'You don\'t have recently viewed properties yet',
    emptyCaption: 'Your viewed properties will be shown here'
};
